
export default function ($q, title, message) {
  $q.notify({
    message: `<div><b>${title}</b></div><div>${message}</div>`,
    html: true,
    color: 'green',
    icon: 'check_circle',
    timeout: 4000
  })
}
